import {
  Button,
  Classes,
  Dialog,
  FileInput,
  FormGroup,
  H5,
  InputGroup,
  Popover,
  Switch,
  Tab,
  Tabs,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import { MvaStoreRS } from "../../stores/mvas/MvaStoreRS";
import { Pager } from "../utils/Pager";
import * as moment from "moment";
import {
  MDBBtn,
  MDBCol,
  MDBRow,
} from "mdbreact";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { MvaRsDialogDuplicar } from "./MvaRsDialogDuplicar";
import { IMvaRS } from "../../model";
import ReactJson from "react-json-view";
import { MvaStorePA } from "../../stores/mvas/MvaStorePA";

var debounce = require('lodash.debounce');

interface State {
  filter: string
}

@observer
export class MvasRsPage extends React.Component<{}, State> {

  obs = observable({
    adding: false as boolean,
    edit_mva: null as IMvaRS,
    duplicar_mva: null as IMvaRS,
    fetchOptions: {} as any,
    loading_export: false as boolean,
    mva_import_open: false as boolean,
    loading_import: false as boolean,
    file_name: "Selecione um arquivo em xlsx igual ao exportado!" as string,
    mvs_details_open: false as boolean,
  })

  constructor(props) {
    super(props)

    this.state = {
      filter: ""
    }

    this.obs.fetchOptions = debounce(this.handleFilterMva.bind(this), 800);

  }

  async componentDidMount() {

    AppStore.setTitle("MVAs Rio Grande do Sul");

    await MvaStoreRS.handlePageFilter(1, "");

  }


  handlePageChange = async (page: number) => {

    await MvaStoreRS.handlePageFilter(MvaStoreRS.obs.currentPage, this.state.filter);

  };

  ncmFormatter(ncm) {
    const ncmHTML = ncm.split("\n")?.map((ncm, index) => {
      return <p>{ncm}</p>;
    });
    return (
      <div>
        {ncmHTML}
      </div>
    );
  }

  validadeFormatter(d) {
    return d ? moment(d).add(3, "hour").format("DD/MM/YYYY") : null;
  }

  validadeFormatterLaw(d) {
    return d ? "Sim" : "Não";
  }

  async handleFilterMva() {

    MvaStoreRS.obs.currentPage = 1

    await MvaStoreRS.handlePageFilter(1, this.state.filter)

  }

  handleChangeVigencia() {

    MvaStoreRS.obs.filter_vigencia = !MvaStoreRS.obs.filter_vigencia;

    MvaStoreRS.handlePageFilter(MvaStoreRS.obs.currentPage, this.state.filter);

  }

  async handleChangeTab(tabId: string) {

    MvaStoreRS.obs.selectedTab = tabId

    MvaStoreRS.obs.filter_vigencia = true
    this.setState({ filter: "" })

    await MvaStoreRS.handlePageFilter(1, "")

  }

  handleChangeFilter(e) {

    this.setState({ filter: e }, () => {

      this.obs.fetchOptions()

    })

  }

  createCustomSearchField = (props) => {
    return (
      <MDBRow>
        <MDBCol xl="10" lg="10" md="10" sm="10">
          <InputGroup
            round
            style={{ borderRadius: "10px" }}
            placeholder="Filtrar (Item, CEST, NCM, Descrição)"
            value={this.state.filter}
            onChange={(e) => this.handleChangeFilter(e.target.value)}
          />
        </MDBCol>

        <MDBCol md="2">
          <MDBBtn
            className="btnDefault btnBuscarNfe"
            style={{ marginTop: 4 }}
            onClick={() => this.handleFilterMva()}
          >
            Buscar
          </MDBBtn>
        </MDBCol>
      </MDBRow>
    );
  };

  async handleAplicaFrete(id, checked) {
    let resp = await MvaStoreRS.handleAplicaFrete(id, checked)

    if (resp) {
      await MvaStoreRS.handlePageFilter(MvaStoreRS.obs.currentPage, this.state.filter);
    }

  }

  async handleExport() {
    this.obs.loading_export = true

    await MvaStorePA.handleExport("rs", MvaStoreRS.obs.selectedTab == "entrada")

    this.obs.loading_export = false
  }

  handleImport() {

    this.obs.mva_import_open = true;

  };

  handleFileInputChange = async (event) => {

    this.obs.loading_import = true;

    const file = event.target.files[0];

    this.obs.file_name = file.name

    var data = new FormData();

    data.append("file", file);
    data.append("entrada", MvaStoreRS.obs.selectedTab == "entrada" ? "true" : "false");
    data.append("estado", "rs");

    this.obs.mva_import_open = false;

    let res = await MvaStorePA.handleImport(data)

    if (res) {

      MvaStoreRS.obs.currentPage = 1;

      await MvaStoreRS.handlePageFilter(1, "")

      this.obs.file_name = "Selecione um arquivo xlsx igual ao exportado!"

    }

    this.obs.loading_import = false;

  };

  handleViewDetalhes(row) {

    this.obs.edit_mva = row

    this.obs.mvs_details_open = true

  }

  mvaFormater(cell, row) {

    return `${cell}%`

  }

  handleDuplicarMva = (mva) => {

    this.obs.duplicar_mva = mva;

  }

  handleDuplicaClose = async () => {

    this.obs.duplicar_mva = null;

    await MvaStoreRS.handlePageFilter(MvaStorePA.obs.currentPage, this.state.filter);

  };

  async handleDeleteMva(id) {

    let res = await MvaStoreRS.handleDeleteMva(id)

    if (res) {

      await MvaStoreRS.handlePageFilter(MvaStorePA.obs.currentPage, this.state.filter);

    }

  }

  render() {

    const buttonFormatterDetalhes = (cell, row) => {

      let user_admin = AppStore.obs1.usuario ? AppStore.obs1.usuario.admin : false

      return (
        <>
          <MDBBtn color="default" rounded size="sm" onClick={(e) => this.handleViewDetalhes(row)} >
            <img src="/images/view.png" width="18px" />
          </MDBBtn>

          {user_admin && <MDBBtn color="default" rounded size="sm" onClick={(e) => this.handleDuplicarMva(row)}>
            <img src="/images/duplicate.svg" width={25} />
          </MDBBtn>}

          {user_admin && row.manual && <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
            <MDBBtn color="default" rounded size="sm">
              <img src="/images/bin.png" width={25} />
            </MDBBtn>
            <div>
              <H5>Confirmar exclusão?</H5>
              <p style={{ fontSize: 11 }}>Tem certeza de que deseja excluir esse item? Você não será capaz de recuperá-lo.</p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 15,
                }}
              >
                <Button
                  className={Classes.POPOVER_DISMISS}
                  style={{ marginRight: 10 }}
                >
                  Cancelar
                </Button>
                <Button
                  intent="danger"
                  className={Classes.POPOVER_DISMISS}
                  onClick={() => this.handleDeleteMva(row._id)}
                >
                  Excluir
                </Button>
              </div>
            </div>
          </Popover>}
        </>
      );
    }

    const buttonFormatterAplicaFrete = (cell, row) => {
      return (
        <div>
          <Switch
            label={row.aplica_frete ? "Sim" : "Não"}
            checked={row.aplica_frete}
            onChange={(e: any) => this.handleAplicaFrete(row._id, e.target.checked)}
          />
        </div>
      );
    }

    const options = {
      searchField: this.createCustomSearchField,
    };

    let user_admin = AppStore.obs1.usuario ? AppStore.obs1.usuario.admin : false

    return (
      <div>
        <MDBRow>
          <MDBCol md="12">
            <Button icon="export" className="btnRoxo" onClick={() => this.handleExport()} loading={this.obs.loading_export} style={{ marginRight: 15 }}>Exportar</Button>
          </MDBCol>
        </MDBRow>

        <Tabs
          id="tabs"
          className={"tabsCalculos"}
          selectedTabId={MvaStoreRS.obs.selectedTab}
          onChange={(tabId) => this.handleChangeTab(String(tabId))}
        >
          <Tab
            id="entrada"
            title="Entrada"
            panel={<></>} />

          <Tab
            id="saida"
            title="Saída"
            panel={<></>} />
        </Tabs>

        <MDBRow>
          <div style={{ display: "flex", width: "100%" }}>
            <Switch
              label={"Filtro Vigência"}
              checked={MvaStoreRS.obs.filter_vigencia}
              onChange={(e: any) => this.handleChangeVigencia()}
              innerLabelChecked="Vigentes" innerLabel="Não vigentes"
              style={{ marginTop: 12, marginLeft: "15px", fontSize: 12, fontWeight: 600 }}
              alignIndicator="right"
            />
          </div>
        </MDBRow>

        <BootstrapTable
          className="TableDefault"
          ref="table"
          data={MvaStoreRS.obs.mvas}
          options={options}
          search
        >
          <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
          <TableHeaderColumn dataField="cest" width="10%">CEST</TableHeaderColumn>
          <TableHeaderColumn dataField="ncm" dataFormat={this.ncmFormatter} width="10%">NCM/SH</TableHeaderColumn>
          <TableHeaderColumn dataField="valido_de" dataFormat={this.validadeFormatter} width="15%">Valido de</TableHeaderColumn>
          <TableHeaderColumn dataField="valido_ate" dataFormat={this.validadeFormatter} width="15%">Valido até</TableHeaderColumn>
          <TableHeaderColumn dataField="segmento" width="15%">Segmento</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.mvaFormater} dataField="mva_positiva" width="15%">Positiva</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.mvaFormater} dataField="mva_neutra" width="15%">Neutra</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.mvaFormater} dataField="mva_negativa" width="15%">Negativa</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.mvaFormater} dataField="mva_ajustada_4" width="15%">Ajustada 4%</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.mvaFormater} dataField="mva_ajustada_7" width="15%">Ajustada 7%</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.mvaFormater} dataField="mva_ajustada_12" width="15%">Ajustada 12%</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.mvaFormater} dataField="mva_ajustada" width="15%">Ajustada</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.mvaFormater} dataField="mva" width="15%">MVA</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.mvaFormater} dataField="aliquota_interna" width="15%">Interna</TableHeaderColumn>
          {user_admin && <TableHeaderColumn dataFormat={buttonFormatterAplicaFrete} width="15%">Aplica Frete</TableHeaderColumn>}
          <TableHeaderColumn dataFormat={buttonFormatterDetalhes} width="10%">Ações</TableHeaderColumn>
        </BootstrapTable>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={MvaStoreRS.obs.currentPage}
            totalCount={MvaStoreRS.obs.length_mvas}
            pageSize={20}
            onPageChange={page => this.handlePageChange(MvaStoreRS.obs.currentPage = page)}
          />
        </div>

        <Dialog isOpen={this.obs.mva_import_open} title={"Importar MVAs - " + MvaStoreRS.obs.selectedTab.toUpperCase()}>
          <div className={Classes.DIALOG_BODY}>

            <p style={{ color: "rgba(255, 0, 0, 0.82)" }}>

              <b>Observação:</b> Ao importar o arquivo, todos os mvas cadastrados no sistema serão substituídos pelos mvas presentes no arquivo, conforme o tipo selecionado na aba. <br />

            </p>

            <br />

            <FormGroup label="">
              <FileInput text={this.obs.file_name} className="bp3-fill bp3-file-input-has-selection input-file-certificado" onInputChange={this.handleFileInputChange} />
            </FormGroup>
          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" intent="primary" onClick={() => this.obs.mva_import_open = false} />
            </div>
          </div>

        </Dialog>

        <Dialog isOpen={this.obs.mvs_details_open} onClose={() => this.obs.mvs_details_open = false}>

          <div className={Classes.DIALOG_BODY} style={{ overflow: "auto", "height": 500 }}>

            <ReactJson displayDataTypes={false} src={this.obs.edit_mva} />

          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" intent="primary" onClick={() => this.obs.mvs_details_open = false} />
            </div>
          </div>

        </Dialog>

        {this.obs.duplicar_mva && <MvaRsDialogDuplicar mva={this.obs.duplicar_mva} onClose={this.handleDuplicaClose} />}

      </div>
    );
  }
}

export default MvasRsPage;
